<template>
  <section
    class="main"
    ref="main"
    id="mainbox"
    @scroll="handleScroll"
    @touchmove="handleScrollmobile"
    @touchend="handleScrollmobile"
  >
    <header
      :class="[
        'headerTitle',
        !mobileMenuVisible ? 'opacity-8' : '',
        videoHeader,
      ]"
    >
      <section class="headerTop pctotok">
        <section class="header-container">
          <img
            class="totokLogo"
            :src="videoHeader ? colorLogo : whiteLogo"
            alt="logo of totok free video call app"
            @click="viewHomepage"
          />
          <!-- <h3 class="totokLabel">ToTok</h3> -->
          <router-link :to="{ name: 'main',query:{lang:this.t(undefined,'ar') } }">{{ t('HOME',' الرئيسية')}}</router-link>
          <router-link
            :to="{ name: 'features',query:{
              lang: this.t(undefined,'ar')
            } }"
            :class="showFeatures ? 'active' : null"
          >
            {{ t("FEATURES","المزايا") }}
          </router-link>
          <router-link
            :to="{ name: 'Aug202104',query:{
              lang: this.t(undefined,'ar')
            } }"
            :class="showNews ? 'active' : null"
          >
            {{ t("NEWS","أخبار") }}
          </router-link>

          <router-link
            :to="{ name: 'download-android',query:{
              lang: this.t(undefined,'ar')
            } }"
            :class="showDownload ? 'active' : null"
          >
            {{ t("DOWNLOAD","تحميل") }}
          </router-link>
          <router-link
            :to="{ name: 'security', query:{
              lang: this.t(undefined,'ar')
            }  }"
            :class="showSecurity ? 'active' : null"
          >
            {{ t("SECURITY","الأمان") }}
          </router-link>
          <!-- <router-link :to="{ name: 'terms'}" :class="{active:showinfo && (showPrivacyTerms || showterms)}">
                        {{$t('privacy_terms')}}
                    </router-link> -->
          <router-link :to="{ name: 'faq' }" :class="showfaq ? 'active' : null">
            {{ t("FAQ","الأسئلة الشائعة ") }}
          </router-link>

          <language :white-was-used="videoHeader==''"
          :language="t('en','ar')"
          @choose-language="chooseLanguage"/>

        </section>
      </section>

      <section class="mobileTotok">
        <img
          :src="
            !isHomePage ? colorLogo : mobileMenuVisible ? whiteLogo : colorLogo
          "
          alt="logo of totok free video call app"
          :class="mobileMenuVisible ? 'menu_logo--open' : 'menu_logo--close'"
          @click="viewHomepage"
        />
        <img
          v-show="!isInWebview"
          :src="
            mobileMenuVisible
              ? isHomePage
                ? require('../../src/assets/img/ic_menu_white.png')
                : require('../../src/assets/img/menu.png')
              : require('../../src/assets/img/close.png')
          "
          alt="ToTok menu"
          @click="menuClickHandle"
          :class="
            mobileMenuVisible
              ? 'mobiletotok-menu-img--open'
              : 'mobiletotok-menu-img--close'
          "
        />
        <section v-show="!mobileMenuVisible" class="mobile-list-item">
          <!--                    <div style="display: list-item">-->
          <ol>
            <li
              class="link"
              :class="showinfo ? 'active' : null"
              @click="show('main')"
            >
              <span>{{ t('HOME',' الرئيسية')}}</span>
            </li>
            <!--                    <li class="link" :class="showdownload?'active':null" @click="show('faq')">-->
            <!--                        <span>Download</span>-->
            <!--                    </li>-->
            <li
              class="link"
              :class="showFeatures ? 'active' : null"
              @click="show('features')"
            >
              <span>{{ t("FEATURES","المزايا") }}</span>
            </li>
            <li
              class="link"
              :class="showNews ? 'active' : null"
              @click="show('news-Aug04-2021')"
            >
              <span>{{ t("NEWS","أخبار") }}</span>
            </li>

            <li
              :class="showDownload ? 'active link' : 'hide'"
              @click="show('download-android')"
            >
              <span>{{ t("DOWNLOAD","تحميل") }} </span>
            </li>
            <li
              class="link"
              :class="showSecurity ? 'active' : null"
              @click="show('security')"
            >
              <span>{{ t("SECURITY","الأمان") }}</span>
            </li>

            <!-- <li class="link" :class="{active:showPrivacyMenu||showterms}" @click="show('privacy_terms')">
                            <span>{{$t('privacy_terms')}}</span>
                            <ul :class="['submenu',!showPrivacyMenu?'hidden':'']">
                                <li class="sub_link" :class="{active:showterms}" @click="show('terms')">
                                    <span>{{$t('terms_of_use')}}</span>
                                </li>
                                <li class="sub_link" :class="{active:showinfo&&showPrivacyTerms}"
                                    @click="show('privacy')">
                                    <span>{{$t('innerPrivacy')}}</span>
                                </li>
                            </ul>
                        </li> -->
            <li
              class="link"
              :class="showfaq ? 'active' : null"
              @click="show('faq')"
            >
              <span>{{ t("FAQ","الأسئلة الشائعة ") }}</span>
            </li>
            <li>
              <language
              :language="t('en','ar')"
              @choose-language="chooseLanguage" :mobile-was-used="true" />
            </li>
          </ol>
        </section>
      </section>
    </header>

    <div class="separator"></div>
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
import Language from "@/components/Language"
const _whiteLogo = require("../assets/img/appicon_totok_white.png");
const _colorLogo = require("../assets/img/appicon_totok_color.png");
export default {
  components: {
    // SvgIcon
    Language
  },
  data() {
    return {
      colorLogo: _colorLogo,
      whiteLogo: _whiteLogo,
      videoHeader: "",
      // showDownload:false,
      mobileHeadTop: 0,
      mobileMenuVisible: true,
      showInfo: false,
      showfaq: false,
      showAbout: false,
      showFeatures: false,
      showNews: false,
      showDownload: false,
      showSecurity: false,
      showPrivacyTerms: false,
      showPrivacyMenu: false,
      showTerms: false,
      showIndex: 0,
    };
  },
  metaInfo() {
    return {
      title: "ToTok Messenger - HD video call and conference call for free",
      meta: [
        {
          Description:
            "ToTok Messenger, apk download, video call, conference call, totok برنامج, مكالمة هاتفية",
        },
        { property: "og:title", content: "ToTok Messenger - HD video call and conference call for free" },
        { property: "og:url", content: "https://totok.ai/" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        {
          property: "og:description",
          content:
            "ToTok Messenger, apk download, video call, conference call, totok برنامج, مكالمة هاتفية",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  computed: {
    isHomePage() {
      return this.$route.name === "main";
    },
    isInWebview() {
      let ua = window.navigator.userAgent.toLowerCase();
      let currentURL = location.href;
      let result = "";
      if (ua.indexOf("totok") >= 0) {
        result = true;
      } else {
        result = false;
      }
      if (currentURL.indexOf("innerview=1") >= 0) {
        result = true;
      }
      return result;
    },
    is_android() {
      let ua = window.navigator.userAgent.toLowerCase();
      return (
        /linux; android/.test(ua) ||
        ua.indexOf("linux") > -1 ||
        ua.indexOf("android") >= 0
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(n, o) {
        if (n && n.name != "main") {
          this.videoHeader = "view_video_header";
        } else {
          this.videoHeader = "";
        }
        let url = location.href;
        if (/privacy/.test(url)) {
          this.showinfo = true;
          this.showfaq = false;
          this.showAbout = false;
          this.showFeatures = false;
          this.showNews = false;
          this.showDownload = false;
          this.showSecurity = false;
          this.showPrivacyTerms = true;
          this.showPrivacyMenu = true;
          this.showterms = false;
          // this.showDownload = false
        } else if (/faq/.test(url)) {
          this.showinfo = false;
          this.showfaq = true;
          this.showAbout = false;
          this.showFeatures = false;
          this.showNews = false;
          this.showDownload = false;
          this.showSecurity = false;
          this.showterms = false;
          this.showPrivacyTerms = false;
        } else if (/news-Aug04-2021/.test(url)) {
          this.showinfo = false;
          this.showfaq = false;
          this.showAbout = false;
          this.showFeatures = false;
          this.showNews = true;
          this.showDownload = false;
          this.showSecurity = false;
          this.showterms = false;
          this.showPrivacyTerms = false;
        } else if (/terms/.test(url)) {
          this.showinfo = true;
          this.showfaq = false;
          this.showAbout = false;
          this.showFeatures = false;
          this.showNews = false;
          this.showDownload = false;
          this.showSecurity = false;
          this.showterms = true;
          this.showPrivacyTerms = true;
          this.showPrivacyMenu = true;
        } else if (/about/.test(url)) {
          this.showinfo = false;
          this.showfaq = false;
          this.showAbout = true;
          this.showFeatures = false;
          this.showNews = false;
          this.showDownload = false;
          this.showSecurity = false;
          this.showterms = true;
          this.showPrivacyTerms = true;
          this.showPrivacyMenu = true;
        } else if (/download-android/.test(url)) {
          this.showinfo = false;
          this.showinfo = false;
          this.showDownload = true;
          this.showSecurity = false;
          this.showfaq = false;
          this.showAbout = false;
          this.showFeatures = false;
          this.showNews = false;
          this.showterms = false;
          this.showPrivacyTerms = false;
          this.showPrivacyMenu = false;
        } else if (/features/.test(url)) {
          this.showinfo = false;
          this.showinfo = false;
          this.showDownload = false;
          this.showSecurity = false;
          this.showfaq = false;
          this.showAbout = false;
          this.showFeatures = true;
          this.showNews = false;
          this.showterms = false;
          this.showPrivacyTerms = false;
          this.showPrivacyMenu = false;
        } else if (/security/.test(url)) {
          this.showinfo = false;
          this.showinfo = false;
          this.showDownload = false;
          this.showSecurity = true;
          this.showfaq = false;
          this.showAbout = false;
          this.showFeatures = false;
          this.showNews = false;
          this.showterms = false;
          this.showPrivacyTerms = false;
          this.showPrivacyMenu = false;
        } else {
          //Home selected
          this.showinfo = true;
          this.showfaq = false;
          this.showAbout = false;
          this.showFeatures = false;
          this.showNews = false;
          this.showDownload = false;
          this.showSecurity = false;
          this.showPrivacyTerms = false;
          this.showterms = false;
          this.showPrivacyMenu = false;
        }
        console.log("showDownload",this.showDownload)
      },
    },
  },
  mounted() {
    this.$refs.main.addEventListener("scroll", this.handleScroll);
  },
  created() {
    let url = location.href;
    if (/privacy/.test(url)) {
      this.showinfo = true;
      this.showfaq = false;
    } else if (/faq/.test(url)) {
      this.showinfo = false;
      this.showfaq = true;
    }
  },
  methods: {
    t(d,ar){
      if(this.$route.query.lang == "ar"){
        if(ar) return ar;
        else return d;
      } else {
        return d;
      }
    },
    chooseLanguage(lang){
      this.$router.push({query:{
        lang
      }})
    },
    viewHomepage() {
      this.$router.push({
        name: "main",
        query:{
          lang:this.t(undefined,"ar")
        }
      });
    },
    menuClickHandle() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
      // this.showinfo = true;
      this.showPrivacyTerms = false;
      this.showPrivacyMenu = false;
      this.showterms = false;
    },
    clickfaq() {
      setTimeout((res) => {
        this.showfaq = true;
        let ua = window.navigator.userAgent.toLowerCase();
        let isAndroid =
          /linux; android/.test(ua) ||
          ua.indexOf("linux") > -1 ||
          ua.indexOf("android") >= 0;
        if (isAndroid) {
          this.$router.push({ name: "faq_list_android" });
        } else {
          this.$router.push({ name: "faq_list_ios" });
        }
      }, 200);
    },
    hiddeninfo(query, index) {
      setTimeout(() => {
        this.mobileMenuVisible = true;
        this.$router.push("/" + query);
        this.showfaq = false;
        this.showinfo = false;
        this.showindex = index;
        setTimeout(() => {
          if (index === 0) {
            this.$refs.main.scrollTop = 0;
          } else if (index === 1) {
            this.$refs.main.scrollTo(0, 630);
          } else if (index === 2) {
            this.$refs.main.scrollTo(0, 1860);
          }
        }, 10);
      }, 10);
    },
    show(loc) {
      let ua = window.navigator.userAgent.toLowerCase();
      let isAndroid =
        /linux; android/.test(ua) ||
        ua.indexOf("linux") > -1 ||
        ua.indexOf("android");
      if (loc === "privacy_terms") {
        this.showPrivacyMenu = !this.showPrivacyMenu;
        this.showinfo = false;
        this.showfaq = false;
        return;
      }
      if (loc === "faq") {
        this.$router.push({ name: "faq" });
      } else if(loc === "news-Aug04-2021"){
        this.$router.push({ name: "Aug202104" });

      }else if (loc === "download-android") {
        if (isAndroid) {
          this.$router.push({ name: "download-android" ,query:{
            lang: this.t(undefined,"ar")
          }});
        }
      } else {
        let maybeLang = undefined;
        if(loc=="features" || loc=="main" || loc == "security"){
          maybeLang = "ar"
        }
        this.$router.push({ name: `${loc}`,query:{
            lang: this.t(undefined,maybeLang)
        } });
      }

      if (this.isPC()) {
        window.scroll(0, 0);
      } else {
        this.$refs.main.scrollTop = 0;
        this.mobileMenuVisible = true;
      }
    },
    isPC() {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SybianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      let flag = true;
      for (const v of Agents) {
        if (userAgentInfo.indexOf(v) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    handleScroll() {
      // this.$refs.main.scrollTop
      let scrolltop = this.$refs.main.scrollTop;
      if (this.isPC()) {
        if (scrolltop >= 0 && scrolltop < 630) {
          this.showindex = 0;
          return;
        }
        if (scrolltop >= 630 && scrolltop < 1559) {
          this.showindex = 1;
          return;
        }
        if (scrolltop >= 1559) {
          this.showindex = 2;
        }
      } else {
        if (scrolltop >= 0 && scrolltop < 500) {
          this.showindex = 0;
          return;
        }
        if (scrolltop >= 500 && scrolltop < 2000) {
          this.showindex = 1;
          return;
        }
        if (scrolltop >= 2000) {
          this.showindex = 2;
        }
      }
    },
    handleScrollmobile() {
      let scrolltop = this.$refs.main.scrollTop;
      this.mobileHeadTop = scrolltop;
      if (!this.isPC()) {
        if (scrolltop >= 0 && scrolltop < 500) {
          this.showindex = 0;
          return;
        }
        if (scrolltop >= 500 && scrolltop < 2000) {
          this.showindex = 1;
          return;
        }
        if (scrolltop >= 2000) {
          this.showindex = 2;
        }
      }
    },
  },
};
</script>
<style scoped lang="stylus">

.hidden {
    display none !important;
}

.router-link-exact-active {
    color: #4378f2;
    padding-bottom: 0px;
    border-bottom: 3px solid #4378f2;
}

@media only screen and (max-width: 700px) {

    .main {
        position: relative;
        margin: 0 auto;
        height: 100vh;
        width:100%;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        color: #333;
        box-sizing: border-box;

        .headerTitle {
            position: absolute;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            padding: 0.8rem 0px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            min-height: 3rem;
            font-size: 0.7rem;
            // box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.02);


            .pctotok {
                display none;
            }

            .mobileTotok {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-end;
                    width: 95%;
                    position: relative;

                .mobile-list-item {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;

                    width: 100%;
                    margin-top: 59px;
                    a {
                        text-decoration: none;
                    }

                    .link {
                        padding: 20px;
                        width: 100%;
                        font-size:17px;
                    }

                    .submenu {
                        display flex;
                        flex-direction column;
                        justify-content center;
                        align-items flex-start;
                        padding-left: 25px;
                        padding-top: 20px;

                        .sub_link {
                            font-size: 15px;
                            color: #333;
                            padding-bottom: 15px;
                        }

                        .sub_link.active {
                            color: #6790f4;
                            font-size: 15px;
                            padding-bottom: 15px;
                        }
                    }


                }
                .menu_logo--open{
                    height: 32px;
                    top: 50%;
                    left: 5%;
                    transform: translateY(-50%);
                    position: absolute;
                }
                .menu_logo--close{
                    height: 32px;
                    top: 25px;
                    left: 5%;
                    transform: translateY(-50%);
                    position: absolute;
                }
                .mobiletotok-menu-img--close{
                    height: 20px;
                    top: 25px;
                    transform: translateY(-50%);
                    position: absolute;
                }
                .mobiletotok-menu-img--open{
                    width:20px;
                    height:20px;
                }
            }

            .link {
                display: inline-block;
                // margin: 1rem 1rem 1rem 0;
                color: #333;
                text-decoration: none;
                cursor: pointer;
                list-style none;
                min-height: 30px;
            }

            .link:active {
                color: #333;
            }

            .link.active {
                color: #6790f4;
                min-height: 30px;
                font-size: 15px;
                list-style: none;
                background-color: #e9eefb;
            }

            .privacy {
                cursor: pointer;

                a {
                    color: #fff;
                    text-decoration: none;

                    &.active {

                    }
                }
            }
        }

        .opacity-8 {
            height 100vh;
            background: #fff;
            z-index: 3;
            justify-content: flex-start;
        }

        .separator {
            width: 100%;
            height: 70px;
        }
    }


}



@media only screen and (min-width: 701px) {
    .main {
        // position: relative;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // align-items: center;
        height: 98vh;
        width:100%;
        // overflow-y: scroll;
        overflow-y: scroll;
        overflow-x: hidden;
        margin: 0 auto;
        color: #333;
        box-sizing: border-box;

        .headerTitle {
            position: fixed;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            top: 0;
            left: 0;
            width: 100%;
            padding-top: 28px;
            padding-bottom:28px;
            font-size: 14px;
            background: rgba(0,0,0,0);
            // box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.02);
            z-index: 1;

            .headerTop {
                margin: 0 auto;
                max-width: 800px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .header-container{
                    width: 800px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .totokLogo{
                    width: 95px;
                    height: 33px;
                    padding-right: 210px;
                    cursor:pointer;
                }
                .totokLabel{
                    display:inline-block;
                    vertical-align: middle;
                    padding-left:5px;
                    margin-right:219px;
                    color:#fff;
                    font-size:18px;
                }
            }

            .mobileTotok {
                display none;
            }

            a {
                color: #fff;
                text-decoration: none;
                font-size: 13px;
                margin-right: 0px;
                letter-spacing: 1px;
                font-weight: 500;
            }
            a:nth-last-child(1){
                margin-right: 0px;
            }

            .privacy {
                text-decoration: none;
                cursor: pointer;

                a {
                    color: #4377f2;
                    text-decoration: none;

                    &.active {
                        color: #4377f2;
                    }
                }
            }
        }
        .view_video_header{
            background:#fff;
            .totokLogo{

            }
            .router-link-exact-active {
                color: #4378f2;
                padding-bottom: 0px;
                border-bottom: 3px solid #4378f2;
            }
            a{
                color: #414141;

            }
        }

    }
}

.fade-enter {
    opacity: 0
}

.fade-leave {
    opacity: 1
}

.fade-enter-active {
    transition opacity .5s
}

.fade-leave-opacity {
    opacity 0;
    transition opacity .5s
}

.active {
    color: #4377f2 !important;
}
.hide{
  display:none;
}
</style>
